(function () {
  'use strict'

  require('./scss/ugc-modal.scss')

  const MODULE_NAME = 'thismoment.glow.component.module.ugc.component.modal'
  const templateUrl = require('./tpl/ugc-modal-cta.html')
  const modalTemplateUrl = require('./tpl/ugc-modal-modal.html')

  require('angular')
    .module(MODULE_NAME, [
      require('../../../../../../common/filter/trustHtml'),
      require('../../../../../../modal'),
      require('../../../../glow-modal'),
      require('../../provider/ugc-api')
    ])
    .component('thismomentGlowModuleUgcModal', {
      templateUrl: templateUrl,
      bindings: {
        moduleId: '<',
        name: '<',
        displayForm: '<'
      },
      controller: glowUgcController
    })

  glowUgcController.$inject = ['$location', '$rootScope', '$scope', '$element', '$stateParams', 'SdkConfig', 'GlowConfig', 'Modal', 'analyticsSDK', 'UgcApi']
  function glowUgcController ($location, $rootScope, $scope, $element, $stateParams, SdkConfig, GlowConfig, Modal, analyticsSDK, UgcApi) {
    var vm = this
    vm.$onInit = ugcInit

    function ugcInit () {
      var backgroundColor, image, margin
      vm.launchGlowUgc = launchGlowUgc
      vm.isUgcOpen = false
      vm.path = $stateParams.path

      $scope.$on('breakpoint:resize', function (event) {
        ugcInit()
        $scope.$apply()
      })

      const ugcModule = GlowConfig.getModule(vm.moduleId)
      vm.constrainAspectRatio = ugcModule.get('constrain_aspect_ratio')
      vm.ctaBackgroundImage = ugcModule.get('cta_background_color')
      vm.ctaHeight = ugcModule.get('cta_height')
      vm.ctaImage = ugcModule.get('cta_image')
      vm.ctaImageAltText = ugcModule.get('cta_image_alt_text')
      vm.ctaMargin = ugcModule.get('cta_margin')
      vm.mobileCtaBackgroundColor = ugcModule.get('mobile_cta_background_color')
      vm.mobileCtaConstrainAspectRatio = ugcModule.get('mobile_constrain_aspect_ratio')
      vm.mobileCtaHeight = ugcModule.get('mobile_cta_height')
      vm.mobileCtaImage = ugcModule.get('mobile_cta_image')
      vm.mobileCtaImageAltText = ugcModule.get('mobile_cta_image_alt_text')
      vm.mobileCtaMargin = ugcModule.get('mobile_cta_margin')

      switch (SdkConfig.get('breakpoint')) {
        case 'xs':
        case 'sm':
          // styles
          if (!vm.mobileCtaImage && !vm.ctaImage) {
            break
          }
          image = vm.mobileCtaImage || vm.ctaImage
          $scope.image = image.url
          backgroundColor = vm.mobileCtaBackgroundColor || vm.ctaBackgroundColor
          margin = vm.mobileCtaMargin || vm.ctaMargin

          // accessibility
          vm.backgroundAltText = vm.mobileCtaImageAltText || vm.ctaImageAltText
          break

        case 'md':
        case 'lg':
          // styles
          if (!vm.mobileCtaImage && !vm.ctaImage) {
            break
          }
          $scope.image = vm.ctaImage.url
          backgroundColor = vm.ctaBackgroundColor
          margin = vm.ctaMargin

          // accessibility
          vm.backgroundAltText = vm.ctaImageAltText
          break
      }

      vm.styles = {
        wrapper: {
          'background-color': backgroundColor,
          margin: margin
        }
      }

      if ($stateParams.modal === 'ugc' && vm.moduleId === parseInt($stateParams.moduleId, 10)) {
        launchGlowUgc($stateParams.moduleId, true)
      }

      $rootScope.$on('modal-ugc-pop', function (event, ugcId) {
        if (ugcId === vm.moduleId) {
          launchGlowUgc(ugcId)
        }
      })
    }

    function launchGlowUgc (moduleId, deeplink) {
      if (vm.isUgcOpen) {
        return
      } else {
        vm.isUgcOpen = true
      }

      const ugcModule = GlowConfig.getModule(moduleId)

      if (!('get' in ugcModule) || ugcModule.get('type') !== 'module_ugc') { exitModal() }

      vm.trackEvent = analyticsSDK.setupEventTracking({
        'module title': ugcModule.get('name'),
        'module type': ugcModule.get('type').replace('module_', ''),
        'tm module id': ugcModule.get('id')
      })

      vm.trackEvent('Module Explored', {
        'event trigger': (deeplink) ? 'deeplinked to UGC promo' : 'clicked UGC promo'
      })

      // modal settings
      $scope.ariaLabel = ugcModule.get('name')
      $scope.cancelBackgroundColor = ugcModule.get('cancel_button_color')
      $scope.cancelColor = ugcModule.get('cancel_button_text_color')
      $scope.cancelText = ugcModule.get('cancel_button_text')
      $scope.errorButtonText = ugcModule.get('error_button_text')
      $scope.errorColor = ugcModule.get('error_color')
      $scope.errorDescription = 'Please try your submission again'
      $scope.errorTitle = ugcModule.get('error_title')
      $scope.fields = ugcModule.get('form_items')
      $scope.processingDescription = ugcModule.get('processing_description')
      $scope.processingTitle = ugcModule.get('processing_title')
      $scope.submissionBackgroundColor = ugcModule.get('submission_background_color')
      $scope.submissionBackgroundImage = ugcModule.get('submission_background_image')
      $scope.submissionFormDescription = ugcModule.get('submission_form_description')
      $scope.submissionFormDescriptionColor = ugcModule.get('submission_form_description_color')
      $scope.submissionFormTitle = ugcModule.get('submission_form_title')
      $scope.submissionFormTitleColor = ugcModule.get('submission_form_title_color')
      $scope.submitBackgroundColor = ugcModule.get('submit_button_color')
      $scope.submitColor = ugcModule.get('submit_button_text_color')
      $scope.submitText = ugcModule.get('submit_button_text')
      $scope.successButtonText = ugcModule.get('success_button_text')
      $scope.successColor = ugcModule.get('success_color')
      $scope.successDescription = ugcModule.get('success_description')
      $scope.successTitle = ugcModule.get('success_title')

      var expanded = Modal()
      expanded.open({
        animation: false,
        component: 'thismomentGlowModal',
        size: 'lg',
        resolve: {
          options: {
            // analytics
            trackEvent: vm.trackEvent,
            parentEvent: 'UGC submission',
            parentType: 'Module',
            // config
            getParentScope: getParentScope, // not using uib's $scope parameter as that does not play nicely
            onSubmit: onSubmit,
            templateUrl: modalTemplateUrl
          }
        }
      }, exitModal, exitModal)()

      $location.search({modal: 'ugc', moduleId: moduleId})

      function onSubmit (formData) {
        return UgcApi.send(formData, ugcModule.get('id'), ugcModule.get('submission_playlist_id'))
      }

      function exitModal () {
        vm.isUgcOpen = false
        $location.search({modal: null, moduleId: null})
        $element[0].focus() // use raw HTML element's `focus` method
      }

      function getParentScope () {
        return $scope
      }
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/glow/component/glow-module/module-ugc/component/ugc-modal/index.js